// API
export const GET_FREE_PRODUCTS_API = '/products/free/uuids';
export const GET_PRODUCTS_PACKETS = '/products/packet?limit=2000&offset=0';
